import { render } from "./Form.vue?vue&type=template&id=68a70e2a"
import script from "./Form.vue?vue&type=script&setup=true&lang=js"
export * from "./Form.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Pages/Form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "68a70e2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68a70e2a', __exports__)) {
    api.reload('68a70e2a', __exports__)
  }
  
  module.hot.accept("./Form.vue?vue&type=template&id=68a70e2a", () => {
    api.rerender('68a70e2a', render)
  })

}


export default __exports__